document.addEventListener("teeinblue-event-component-injected", function () {
  const elementToMove = document.querySelector(".WhatsApp");
  const insertAfterElement = document.querySelector("div#teeFormActions");
  if (elementToMove && insertAfterElement) {
    insertAfterElement.after(elementToMove);
  }
});
document.addEventListener('teeinblue-event-after-cart-added', () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
        fetch(window.location.pathname + "?sections=cart-drawer,cart-icon-bubble")
        .then(res => res.json())
        .then(res => drawer.renderContents({sections: res}));
        if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
    }
});